var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipCopyActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 10H4.8C4.72044 10 4.64413 9.96839 4.58787 9.91213C4.53161 9.85587 4.5 9.77956 4.5 9.7V4.8C4.5 4.72044 4.53161 4.64413 4.58787 4.58787C4.64413 4.53161 4.72044 4.5 4.8 4.5H9.7C9.77956 4.5 9.85587 4.53161 9.91213 4.58787C9.96839 4.64413 10 4.72044 10 4.8V9.7C10 9.77956 9.96839 9.85587 9.91213 9.91213C9.85587 9.96839 9.77956 10 9.7 10Z",
    stroke: "#2563EB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5V2.3C7.5 2.22044 7.46839 2.14413 7.41213 2.08787C7.35587 2.03161 7.27956 2 7.2 2H2.3C2.22044 2 2.14413 2.03161 2.08787 2.08787C2.03161 2.14413 2 2.22044 2 2.3V7.2C2 7.27956 2.03161 7.35587 2.08787 7.41213C2.14413 7.46839 2.22044 7.5 2.3 7.5H4.5",
    stroke: "#2563EB",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipCopyActiveIcon);
export default __webpack_public_path__ + "static/media/tooltip-copy-active-icon.6dc2a5ab88ae08031e39c97619d4e9ae.svg";
export { ForwardRef as ReactComponent };